export const filterTermine = (termin) => {
  return !termin.node.frontmatter.hidden;
}
